module.exports = __webpack_public_path__ + "img/pc-banner.724079f4.png";